import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";

export const mobileWindowGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  let isMobile = window.innerWidth <= 768;

  if(isMobile) {
    return true;
  } else {
    router.navigate(['products']).catch();
    return false;
  }
};
